<template>
  <div>
    <!-- 弹窗-添加/修改 -->
    <simple-modal 
      ref    ="modal"
      :title ="title"
      :right ="true"
      :middle="true"
      @submit="submit"
    >
      <template slot="body">
        <!--  -->
        <div class="member-modal-form">
          <p class="member-title">
            {{$I18n("base_info")}}
          </p>
          <common-form-item 
            :labelweight="100"
            v-for="item in formItem_basic" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
            :style="item.keys === 'icon' ?{'align-items': 'flex-start'} :{}"
          >
            <!-- Label -->
            <template slot="label">
              <p class="member-form-label" style="">
                <i v-if="item.keys === 'phone'" class="more-info-span">!
                  <!-- Tooltip on top -->
                  <md-tooltip md-direction="bottom">{{$I18n("member_info_01")}}</md-tooltip>
                </i>
                <i v-if="item.keys === 'email'" class="more-info-span">!
                  <!-- Tooltip on top -->
                  <md-tooltip md-direction="bottom">{{$I18n("member_info_02")}}</md-tooltip>
                </i>
                <i v-if="item.keys === 'remote_unlock'" class="more-info-span">!
                  <!-- Tooltip on top -->
                  <md-tooltip md-direction="bottom">{{$I18n("member_info_02")}}</md-tooltip>
                </i>
                <i v-if="item.required" :style="{color: 'red'}">*</i>
                {{item.label_s}}
              </p>
            </template>
            <!-- 其他 -->
            <template slot="tail" v-if="item.keys !== 'phone' && item.keys !== 'email'">
              <p class="member-form-tail" style="margin: 0;"></p>
            </template>
            <!-- 手机号 -->
            <template slot="tail" v-if="item.keys === 'phone'">
              <div class="member-form-tail">
                <div class="teil-icon" @click="showEmail = !showEmail">
                  <img src="/img/haiqora/Frame_1.png" style="width: 17px;height: 17px;position: relative; "/>
                </div>
              </div>
            </template>
            <!-- 邮箱 -->
            <template slot="tail" v-if="item.keys === 'email'">
              <div class="member-form-tail">
                <div class="teil-icon" @click="showEmail = !showEmail">
                  <img src="/img/haiqora/Frame_2.png" style="width: 17px;height: 17px;position: relative; "/>
                </div>
              </div>
            </template>

            <!-- 图片选择 -->
            <div slot="user_icon" style="display: inline-block;">
              <el-tooltip placement="right">
                <div slot="content" style="margin: -9px;">
                  <img src="/img/haiqora/info_en.png" width="255" />
                </div>
                <image-select
                  :path="formData.Form.user_icon" 
                  @updatePath="uploadIcon" 
                  :file_type="['jpg','jpge','png']"
                  :selectBoxCss="{width:'86px',height:'67px',border:'1px #BBBBBB dashed',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',}"
                >
                  <img src="/img/haiqora/face.png" style="width: 41px;height: 43px;"/>
                  <p style="font-size: 10px;line-height: 12px;margin-top: 2px;margin-bottom: 0px;">{{$I18n("upload_photo")}}</p>
                </image-select>
              </el-tooltip>
            </div>
          </common-form-item >

          <!--  -->
          <p class="member-title" style="margin-top:10px;">
            {{$I18n("ext_info")}}
          </p>
          <common-form-item 
            :labelweight="100"
            v-for="item in formItem_extend" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
            :style="item.keys === 'icon' ?{'align-items': 'flex-start'} :{}"
          >
            <template slot="label">
              <p class="member-form-label">
                <i v-if="item.keys === 'access_pwd'" class="more-info-span">!
                  <!-- Tooltip on top -->
                  <md-tooltip md-direction="bottom">{{$I18n("member_info_03")}}</md-tooltip>
                </i>
                {{item.label_s}}
                <i v-if="item.required" :style="{color: 'red'}">*</i>
              </p>
            </template>
            <el-date-picker
              slot="daterange"
              class="md-date-form-item"
              align="left"
              v-model="member_valid_date"
              type="datetimerange"
              :clearable="false"
              range-separator=" ~ "
              value-format="yyyy-MM-dd HH:mm:SS"
              :start-placeholder="$I18n('start')"
              :end-placeholder="$I18n('end')">
            </el-date-picker>
          </common-form-item >
        </div>
      </template>
      <template slot="footer-btn">
        <md-button v-if="type === 'add'" class="diy-back-blue md-info left-icon" @click="add_c">{{$I18n("add_and_continue")}}</md-button>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass,timestampToString1000,emailLegal } from "@/common/tools.js";
export default {
  name: "modal-member",
  props:["organi", "deptData"],
  data() {
    let formData = new FormClass({ // 弹窗-表单数据
      area: "86",
      home_id: this.organi,
      id: 0,
      role_id: 3,
      state: 1,
      force: 0,

      gmt_end  : {
        init: parseInt(new Date().getTime()/1000),
        check: function(val, formValue){
          if(![2,3,5].includes(formValue.user_type)){
            return false
          } else {
            return isNaN(val) || val === 0
          }
        },
      },
      gmt_start: {
        init: parseInt(new Date().getTime()/1000),
        check: function(val, formValue){
          if(![2,3,5].includes(formValue.user_type)){
            return false
          } else {
            return isNaN(val) || val === 0
          }
        },
      },
      total_count: {
        init: 0,
        check: function(val, formValue){
          if(![4,5].includes(formValue.user_type)){
            return false
          } else {
            return isNaN(val) || val <= 0 || val > 1000
          }
        },
      },

      access_pwd: {
        init: "",
        errormsg: this.$I18n("pls_check_6int"),
        check: function(val){
          if(!val){
            return false
          }
          return val.length !== 6 || isNaN(val)
        }
      },
      addr: {
        init: "",
        check: function(val){
          if(!val){
            return false
          }
          return val.length > 128
        },
      },
      card_num: {
        init: "",
        check: function(val){
          if(!val){
            return false
          }
          return !/^[A-Za-z0-9]{0,32}$/.test(val)
        }
      },
      email: "",
      id_num: "",
      job_num: "",
      phone: "",
      user_icon: "",
      user_name: {
        init: "",
        check:"smallstr",
      },
      dept_id: "",
      gender: 0,
      list_type: 1,
      user_type: 1,
      remote_unlock: true,  // ture == 1 false == 0
    });
    formData.ErrorPriority = ["access_pwd"]
    return{
      showEmail: false,
      title:"Add Personnel",
      type :"add",
      formData,
      depts: [],
    }
  },
  created(){
  },
  computed: {
    member_valid_date:{
      get(){
        return [timestampToString1000(this.formData.Form.gmt_start), timestampToString1000(this.formData.Form.gmt_end)]
      },
      set(newValue){
        if(!newValue){
          return
        }
        this.formData.Form.gmt_start = new Date(newValue[0]).getTime() / 1000;
        this.formData.Form.gmt_end   = new Date(newValue[1]).getTime() / 1000;
      },
    },
    formItem_basic(){
      return[
        {
          label_s : this.$I18n("photo"),
          keys    : "user_icon",
          type    : "image",
        },{
          label_s  : this.$I18n("name"),
          keys     : "user_name",
          type     : "input",
          check    : true,
          required : true,
          placeholder: this.$I18n("pls_enter_name"),
        },{
          label_s  : this.$I18n("telephone_num"),
          keys     : "phone",
          type     : "input",
          check    : true,
          disabled : this.type === "edit",
          placeholder: this.$I18n("pls_enter_phone"),
          hide     : this.showEmail,
        },{
          label_s  : this.$I18n("email"),
          keys     : "email",
          type     : "input",
          check    : true,
          disabled : this.type === "edit",
          placeholder: this.$I18n("pls_enter"),
          hide     : !this.showEmail,
        },{
          label_s  : this.$I18n("sectoral"),
          keys     : "dept_id",
          type     : "filter-tree-select",
          check    : true,
          required : true,
          treeWeight: 270,
          options  : this.deptData,
          placeholder: this.$I18n("default_sector"),
        },{
          label_s  : this.$I18n("remote_door_open"),
          keys    : "remote_unlock",
          type    : "switch",
        },
      ]
    },
    formItem_extend(){
      return [
        {
          label_s  : this.$I18n("type_person"),
          keys     : "user_type",
          type     : "select",
          options  : this.$Param.memberListType.map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          }),
          placeholder: "",
        },{ // 有效时间
          label_s  : this.$I18n("valid_date"),
          keys     : "daterange",
          required : true,
          hide     : ![2,3,5].includes(this.formData.Form.user_type),
        },{ // 有效次数
          label_s  : this.$I18n("valid_time"),
          keys     : "total_count",
          type     : "input",
          required : true,
          check    : true,
          hide     : ![4,5].includes(this.formData.Form.user_type),
        },{
          label_s  : this.$I18n("type_list"),
          keys     : "list_type",
          type     : "select",
          options  : this.$Param.memberListState.map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          }),
        },{
          label_s  : this.$I18n("acc_ctl_group"),
          keys     : "----",
          type     : "select",
          options  : [],
        },{
          label_s  : this.$I18n("card_num"),
          keys     : "card_num",
          type     : "input",
          check    : true,
          placeholder: this.$I18n("pls_enter_card_num"),
        },{
          label_s  : this.$I18n("access_code"),
          keys     : "access_pwd",
          check    : true,
          type     : "password",
          placeholder: this.$I18n("pls_enter_acc_code"),
        },{
          label_s  : this.$I18n("job_title"),
          keys     : "job_num",
          type     : "input",
          placeholder: this.$I18n("ple_enter_jub_title"),
        },{
          label_s  : this.$I18n("id_card"),
          keys     : "id_num",
          type     : "input",
          placeholder: this.$I18n("pls_enter_id_card"),
        },{
          label_s  : this.$I18n("address"),
          keys     : "addr",
          type     : "input",
          check    : true,
          placeholder: this.$I18n("pls_enter_address"),
        },{
          label_s  : this.$I18n("gender"),
          keys     : "gender",
          type     : "input",
          placeholder: this.$I18n("pls_select"),
        },{
          label_s  : this.$I18n("note"),
          keys     : "note",
          type     : "input",
          placeholder: this.$I18n("pls_enter"),
        },
      ]
    },
  },
  methods:{
    /*
      type : add | edit | del
      data : 表单基础数据
    */
    open(type, data){
      this.type = type;
    
      this.depts = this.UserInfo.depts;
      if(this.depts.length > 0){
        this.formData.SetInit(this.depts[0].id, "dept_id")
      }
      if(type === "add"){
        this.$refs.modal.open();
        this.formData.Reset();
        this.title = this.$I18n("add_person");
      } else if(type === "edit"){
        this.$refs.modal.open();
        if(data.phone){
          this.showEmail = false;
        } else {
          this.showEmail = true;
        }
        this.formData.Update(data);
        this.title = this.$I18n("edit_person")
      
      } else if(type === "del"){
        this.formData.Update(data);
        /* Body | title */
        this.$confirm(this.$I18n("conf_del"), this.$I18n("del_person"), {
          confirmButtonText: this.$I18n("sure"),
          cancelButtonText : this.$I18n("cancle"),
          type: 'warning'
        }).then(() => {
          this.submit();
        }).catch(() => { })
      }
    },
    submit(){
      if(this.type === "add"){
        this.add();
      } else if(this.type === "edit"){
        this.edit();
      } else if(this.type === "del"){
        this.del();
      }
    },
    // 调用父组件传递的close方法
    close(){
      this.$refs.modal.close();
      if(this.$listeners["close"]){
       this.$emit('close');
      }
    },
    uploadIcon(value, filename){
      this.formData.Form.user_icon = value;
      let name = filename.split(".")
      name.pop()
      this.formData.Form.user_name = name.join(".")
    },
    errorResult(error){
      if(error.code == 8012){
        this.$errorMsg(this.$I18n("http_error_409_2"));
      } else if(error.code == 8010){
        if(this.showEmail){
          this.$errorMsg(this.$I18n("error_code_8010_2"))
        } else {
          this.$errorMsg(this.$I18n("error_code_8010_3"))
        }
      } else {
        this.$errorMsg(this.$I18n("add_fail"));
      }
    },
    add_c(){
      if(!isNaN(this.formData.Form.total_count)){
        if(parseInt(this.formData.Form.total_count) > 1000){
          this.formData.Form.total_count = 1000;
        } else {
          this.formData.Form.total_count = Math.max(parseInt(this.formData.Form.total_count), 1);
        }
      } else {
        this.formData.Form.total_count = 1
      }
      if(this.formData.Check()){
        this.$errorMsg(this.formData.ErrMsg ?this.formData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      if(this.showEmail && !emailLegal(this.formData.Form.email)){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.a_Member({
        ...this.formData.Form,
        remote_unlock: this.formData.Form.remote_unlock?1 :0,  // ture == 1 false == 0
        role_id: 3,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
        }))
        .catch(this.errorResult)
    },
    add(){
      if(!isNaN(this.formData.Form.total_count)){
        if(parseInt(this.formData.Form.total_count) > 1000){
          this.formData.Form.total_count = 1000;
        } else {
          this.formData.Form.total_count = Math.max(parseInt(this.formData.Form.total_count), 1);
        }
      } else {
        this.formData.Form.total_count = 1
      }
      if(this.formData.Check()){
        this.$errorMsg(this.formData.ErrMsg ?this.formData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      if(this.showEmail && !emailLegal(this.formData.Form.email)){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.a_Member({
        ...this.formData.Form,
        remote_unlock: this.formData.Form.remote_unlock?1 :0,  // ture == 1 false == 0
        role_id: 3,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.close();
        }))
        .catch(this.errorResult)
    },
    edit(){
      if(!isNaN(this.formData.Form.total_count)){
        if(parseInt(this.formData.Form.total_count) > 1000){
          this.formData.Form.total_count = 1000;
        } else {
          this.formData.Form.total_count = Math.max(parseInt(this.formData.Form.total_count), 1);
        }
      } else {
        this.formData.Form.total_count = 1
      }
      if(this.formData.Check()){
        this.$errorMsg(this.formData.ErrMsg ?this.formData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      this.$api.s_Member({
        ...this.formData.Form,
        remote_unlock: this.formData.Form.remote_unlock?1 :0,  // ture == 1 false == 0
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.close();
        }))
        .catch(this.errorResult)

    },
    del(){
      this.$api.d_Member(this.formData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.close();
        }))
        .catch(this.$Catch(this.$I18n("delete_fail")))
    },
  },
}
</script>

<style scoped>
  .modal-body.text-center .member-modal-form .modal-item{
    margin-bottom: 15px;
  }
  /* 手机 / 邮箱ICON */
  .teil-icon{
    border-radius: 50%;
    height: 32px;
    width: 32px;
    text-align: center;
    line-height: 32px;
    background: #E5E5E5;
    margin-left: 17px;
  }
  /* 小标题 */
  .member-title{
    margin: -10px 0 14px 15px;
    color: #888888;
    font-size: 16px;
    font-weight: 400;
  }
  /* Label 额外信息 ICON */
  .more-info-span{
    border: 1px solid #578EFF;
    height: 12px;
    width: 12px;
    line-height: 12px;
    color: #578EFF;
    display: inline-block;
    text-align: center;
    border-radius: 50%;
    font-size: 8px;
    font-weight: 800;
    font-style: normal;
  }
  /* 尾部 */
  .member-form-tail{
    width: 160px;
    margin: 0;
    padding-right: 10px;
    box-sizing: border-box;
  }
  /* Label */
  .member-form-label{
    margin: 0;
    width: 182px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    text-align: right;
    line-height: 24px;
    padding-right: 13px;
  }
  /deep/ .md-has-password .md-icon.md-theme-default{
    left: -28px;
  }
</style>